module.exports = __webpack_public_path__ + "static/media/RaulM.e53c856b.jpg";